import { TAG_STATUS } from '@evinced-private/ui-common';

import ArrowGreenUpSmall from 'src/resources/icons/ArrowGreenUpSmall.svg?raw';
import ArrowRedDownSmall from 'src/resources/icons/ArrowRedDownSmall.svg?raw';

import { STATUS_MAPPING, TREND_MAPPING } from '../constants';
import { AccessibilityStatus, StatusTag, TrendDirection, TrendTag } from '../types';

import { AccessibilityMetric } from './accessibilityHelpers';

export const getStatusTag = (status: AccessibilityStatus): StatusTag => STATUS_MAPPING[status];

export const getNAStatusTag = (): StatusTag => ({
	status: TAG_STATUS.INFO,
	text: 'N/A'
});

export const getTrendTag = (metric: AccessibilityMetric): TrendTag => {
	// Handle N/A case
	if (metric.value === '0') {
		return {
			status: TAG_STATUS.INFO,
			text: 'N/A'
		};
	}

	const isPositive = metric.trend.direction === TrendDirection.UP;
	// For accessibility issues: UP (more issues) = bad = red arrow, DOWN (fewer issues) = good = green arrow
	// Match colors to sentiment: red for bad trends, green for good trends
	const icon = isPositive ? ArrowRedDownSmall : ArrowGreenUpSmall;
	const status = TREND_MAPPING[metric.trend.direction];
	const text = `${isPositive ? '+' : ''}${metric.trend.percentage}%`;

	return { icon, status, text };
};

export const getTrendAriaLabel = (metric: AccessibilityMetric): string => {
	if (metric.value === '0') {
		return 'No data available';
	}
	return `Trend: ${metric.trend.direction} by ${metric.trend.percentage}%`;
};
